import React, { useState, useEffect, useRef } from 'react';

const SearchableSelectInput = ({ name, value, options, onChange, className, disabled, placeholder = 'Search...' }) => {
  const [query, setQuery] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const rootRef = useRef(null);

  const selectedOption = options.find((opt) => String(opt.value) === String(value));

  useEffect(() => {
    if (!isOpen) {
      setQuery(selectedOption ? selectedOption.label : '');
    }
  }, [selectedOption, isOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const filteredOptions = options.filter((opt) =>
    (opt.label || '').toLowerCase().includes(query.toLowerCase())
  );

  const handleSelect = (option) => {
    onChange(name, option.value);
    setQuery(option.label);
    setIsOpen(false);
  };

  const handleFocus = () => {
    setQuery('');
    setIsOpen(true);
  };

  return (
    <div className={`relative ${className}`} ref={rootRef}>
      <input
        type="text"
        id={name}
        name={name}
        className="w-full border-2 border-gray rounded-lg p-4 bg-white focus:outline-none focus:ring-2 focus:ring-purple-600"
        value={isOpen ? query : (selectedOption ? selectedOption.label : '')}
        onChange={(e) => setQuery(e.target.value)}
        onFocus={handleFocus}
        placeholder={placeholder}
        disabled={disabled}
      />
      {isOpen && !disabled && (
        <ul className="absolute z-20 mt-1 w-full max-h-56 overflow-auto rounded-lg border-2 border-gray bg-white shadow-lg p-0">
          {filteredOptions.length > 0 ? (
            filteredOptions.map((opt) => (
              <li key={opt.value} className="list-none">
                <button
                  type="button"
                  className={`w-full text-left px-4 py-3 text-sm hover:bg-purple-100 ${
                    String(opt.value) === String(value) ? 'bg-purple-50 font-bold' : ''
                  }`}
                  onClick={() => handleSelect(opt)}
                >
                  {opt.label || 'None'}
                </button>
              </li>
            ))
          ) : (
            <li className="px-4 py-3 text-sm text-gray-500 list-none">No options found</li>
          )}
        </ul>
      )}
    </div>
  );
};

export default SearchableSelectInput;
